import { render } from "./DiffContentViewerCompare.vue?vue&type=template&id=3c2f8834"
import script from "./DiffContentViewerCompare.vue?vue&type=script&lang=js"
export * from "./DiffContentViewerCompare.vue?vue&type=script&lang=js"

import "./DiffContentViewerCompare.vue?vue&type=style&index=0&id=3c2f8834&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__